import React, { useEffect } from 'react';
import { Button, Col, Form, message, Select } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { requiredRule } from 'utils/forms/validationRules';
import { UserService } from 'services/UserService';
import { REQUEST_LOADING } from 'constants/alerts';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import { SectionTitle } from 'ui/SectionTitle';

function RolePartForm({
  initialValues,
  userId,
  selectItems,
  onFetch,
  onResetStep,
  onMovePrev,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      const { roles, tribes } = initialValues;

      const roleIds = roles?.map((role) => role.id);
      const tribeIds = tribes?.map((tribe) => tribe.id);

      const rolesList = [];

      for (let i = 0; i < roles.length; i += 1) {
        rolesList.push({ role_id: roleIds[i], tribe_id: tribeIds[i] });
      }

      form.setFieldsValue({
        roles: rolesList,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = async (values) => {
    if (!values.roles.length) {
      message.error('Выберите роль и трайб');
      return;
    }

    let payload;

    if (initialValues) {
      payload = values.roles.map((item) => {
        item.user_id = initialValues?.id;

        return item;
      });
    } else {
      payload = values.roles.map((item) => {
        item.user_id = userId;

        return item;
      });
    }

    const hide = message.loading(REQUEST_LOADING);

    try {
      const isAttached = await UserService.attachRoleToUser(payload);

      if (isAttached) {
        form.resetFields();
        onResetStep();
        onFetch();
        message.success(
          `Роль успешна ${initialValues ? 'отредактирована' : 'добавлена'}`
        );
      }
    } catch (err) {
      message.error(
        `Не удалось  ${
          initialValues ? 'отредактировать' : 'добавить'
        } роль для этого пользователя`
      );
    } finally {
      hide();
    }
  };

  return (
    <Form
      form={form}
      labelCol={{
        span: LABEL_SPAN,
      }}
      wrapperCol={{ span: CONTENT_SPAN }}
      layout="horizontal"
      labelAlign="right"
      onFinish={handleSubmit}
    >
      <SectionTitle>Роли</SectionTitle>

      <Form.List name="roles" initialValue={[{}]}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name }) => (
              <div key={key}>
                <Form.Item
                  name={[name, 'role_id']}
                  label="Роли"
                  rules={[requiredRule]}
                >
                  <Select
                    allowClear
                    showArrow
                    showSearch
                    placeholder="Выберите роль"
                    optionFilterProp="children"
                  >
                    {selectItems.roles.map(({ id, name }) => (
                      <Select.Option key={id} value={id}>
                        {name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name={[name, 'tribe_id']}
                  label="Трайб"
                  rules={[requiredRule]}
                >
                  <Select
                    allowClear
                    showArrow
                    showSearch
                    multiple
                    placeholder="Выберите трайб"
                    optionFilterProp="children"
                  >
                    {selectItems.tribes.map(({ id, title }) => (
                      <Select.Option key={id} value={id}>
                        {title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Col offset={CONTENT_SPAN}>
                  <Button
                    icon={<DeleteOutlined />}
                    type="primary"
                    style={{ marginBottom: '20px' }}
                    onClick={() => remove(name)}
                  >
                    Удалить
                  </Button>
                </Col>
              </div>
            ))}
            <Col offset={CONTENT_SPAN}>
              <Form.Item>
                <Button
                  icon={<PlusOutlined />}
                  style={{ marginBottom: '20px' }}
                  onClick={() => add()}
                >
                  Еще роль
                </Button>
              </Form.Item>
            </Col>
          </>
        )}
      </Form.List>

      <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
        <Button type="primary" htmlType="submit">
          Сохранить
        </Button>
        {initialValues && (
          <Button style={{ marginLeft: '8px' }} onClick={() => onMovePrev()}>
            Назад
          </Button>
        )}
      </Form.Item>
    </Form>
  );
}

export { RolePartForm };
